// Source/Product-Info-Tab/Debounce.ts
function debounce(callback, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(args), timeout);
  };
}

// Source/Product-Info-Tab/Component.ts
var Selector_Text_Shallow = `.Product-Info-Text`;
var Selector_Text_Deep = `.Product-Info-Text .metafield-rich_text_field`;
var Selector_Expand = `input`;
var Selector_Title = `.Product-Info-Title`;

class Component extends HTMLElement {
  parts;
  constructor() {
    super();
    const tab = document.querySelector(`#Product-Info-Tab--${this.dataset.type}`);
    this.parts = {
      expand: this.querySelector(Selector_Expand),
      title: this.querySelector(Selector_Title),
      text: this.querySelector(Selector_Text_Deep) ?? this.querySelector(Selector_Text_Shallow),
      tab
    };
    this.setup();
  }
  setup() {
    const { expand, title, tab } = this.parts;
    tab.addEventListener("click", () => {
      expand.checked = false;
      setTimeout(() => {
        this.updateHeight();
      }, 0);
    });
    this.updateHeight();
    window.addEventListener("resize", debounce(this.updateHeight.bind(this), 150));
    expand.addEventListener("click", () => {
      if (expand.checked)
        return;
      title.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center"
      });
    });
  }
  updateHeight() {
    const height = this.parts.text.scrollHeight;
    this.dataset.showExpand = window.innerWidth < 750 ? String(height > 150) : String(height > 300);
  }
}
// Source/Product-Info-Tab/mod.ts
customElements.define("product-info-tab", Component);
export {
  Component as ProductInfoTab
};
